<template>
  <div class="yxy-circle">
    <svg viewBox="0 0 100 100">
      <path :d="pathString" :stroke="trailColor" :stroke-width="trailWidth" :fill-opacity="0"/>
      <path :d="pathString" :stroke-linecap="strokeLinecap" :stroke="currentStrokeColor" :stroke-width="strokeWidth" fill-opacity="0" :style="pathStyle"/>
    </svg>
    <div class="yxy-circle-content"><slot></slot></div>
  </div>
</template>

<script>
/**
* Fork from https://github.com/react-component/progress
* MIT license
*/
export default {
  props: {
    strokeWidth: {
      type: Number,
      default: 1
    },
    strokeColor: {
      type: String,
      // default: '#3FC7FA'
      default: '#3a90e4'
    },
    trailWidth: {
      type: Number,
      default: 1
    },
    trailColor: {
      type: String,
      default: '#D9D9D9'
    },
    percent: {
      type: Number,
      default: 0
    },
    strokeLinecap: {
      type: String,
      default: 'round'
    },
    autoColor: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    radius () {
      return 50 - this.strokeWidth / 2
    },
    pathString () {
      return `M 50,50 m 0,-${this.radius}
      a ${this.radius},${this.radius} 0 1 1 0,${2 * this.radius}
      a ${this.radius},${this.radius} 0 1 1 0,-${2 * this.radius}`
    },
    len () {
      return Math.PI * 2 * this.radius
    },
    pathStyle () {
      return {
        'stroke-dasharray': `${this.len}px ${this.len}px`,
        'stroke-dashoffset': `${((100 - this.percent) / 100 * this.len)}px`,
        'transition': 'stroke-dashoffset 0.6s ease 0s, stroke 0.6s ease'
      }
    },
    currentStrokeColor () {
      if (!this.autoColor) {
        return this.strokeColor
      }
      if (this.percent >= 0 && this.percent <= 25) {
        return '#ff5500'
      } else if (this.percent > 25 && this.percent <= 50) {
        return '#3FC7FA'
      } else if (this.percent > 50 && this.percent <= 75) {
        return '#FFD700'
      } else if (this.percent > 75 && this.percent < 100) {
        return '#7CFC00'
      } else if (this.percent === 100) {
        return '#09BB07'
      }
    }
  }
}
</script>

<style>
.yxy-circle {
  position: relative;
  width: 100%;
  height: 100%;
}
.yxy-circle-content {
  width: 100%;
  text-align: center;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
}
</style>
